import { render } from "./YTable.vue?vue&type=template&id=0c96d772&scoped=true"
import script from "./YTable.vue?vue&type=script&lang=js"
export * from "./YTable.vue?vue&type=script&lang=js"

import "./YTable.vue?vue&type=style&index=0&id=0c96d772&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c96d772"]])

export default __exports__